import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import TopNav from '../components/TopNav';
import {topNav} from '../config/Nav';
import {withRouter} from 'react-router-dom';
import last from 'lodash/last';
import classNames from 'classnames';
import {onProcessingImagesToggle} from '../actions/ImageActions';

@withRouter
@connect(state => ({
    isAuthenticated: state.auth.isAuthenticated,
    currentUser: state.auth.currentUser,
    processingImagesVisible: state.processingImages.visible,
}), {onProcessingImagesToggle})
export default class TopNavContainer extends Component {
    static propTypes = {
        isAuthenticated: PropTypes.bool,
        currentUser: PropTypes.object,
        processingImagesVisible: PropTypes.bool,
        onProcessingImagesToggle: PropTypes.func,
        isDropdownMenu: PropTypes.bool,
    };

    handleMenuItemClick = (path) => {
        if (last(path) === 'processing') {
            this.props.onProcessingImagesToggle();
        }
    };

    handleCreateMenuItemLabel = (path) => {
        if (last(path) === 'processing') {
            return <span><span className={classNames({checkmark: this.props.processingImagesVisible})}/>{'processing images'}</span>;
        }
        return null;
    };

    render() {
        const {isAuthenticated, currentUser, isDropdownMenu} = this.props;
        const menuConfig = topNav(currentUser, isAuthenticated);
        return (
            <TopNav
                brand="deep contrast"
                menuConfig={menuConfig}
                onCallbackMenuItemClick={this.handleMenuItemClick}
                onCreateMenuItemLabel={this.handleCreateMenuItemLabel}
                isDropdownMenu={isDropdownMenu}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/TopNavContainer.js